import { z } from 'zod';

export const Url = z.string().url();

export type Url = z.infer<typeof Url>;
